<li py-0 flex list-none>
	<a href="/guesser" flex items-center gap-2 py-0>
		<i i-carbon-location block w5 h5></i>
		Guesser
	</a>
</li>

<li py-0 flex list-none>
	<a href="/blog" flex items-center gap-2 py-0>
		<i i-carbon-blog block w5 h5></i>

		Blog
	</a>
</li>
